import { FormValues } from '@wix/form-viewer';
import { WixFormFields } from '../../../../types/wix-forms';
import { IntakeFormErrorType } from '../../../../types/errors';
import { hasEmailMismatchWithIntakeForms } from '../../../../utils/intakeFormUtils';
import { IntakeForms } from '../../../../utils/state/types';

export interface IntakeFormValidationActions {
  addError: (errorType: IntakeFormErrorType) => void;
  removeErrors: (errorTypes: IntakeFormErrorType[]) => void;
}

export const handleIntakeFormEmailValidation = (
  values: FormValues,
  intakeForms: IntakeForms | undefined,
  actions: IntakeFormValidationActions,
): void => {
  const emailFieldValue = values[WixFormFields.EMAIL];

  if (!emailFieldValue) {
    return;
  }

  actions.removeErrors([
    IntakeFormErrorType.COMPLETE_CLIENT_DETAILS_BEFORE_INTAKE,
  ]);

  const emailMismatch = hasEmailMismatchWithIntakeForms(
    emailFieldValue as string,
    intakeForms,
  );

  if (emailMismatch) {
    actions.addError(IntakeFormErrorType.EMAIL_MISMATCH_WITH_INTAKE_FORM);
  } else {
    actions.removeErrors([IntakeFormErrorType.EMAIL_MISMATCH_WITH_INTAKE_FORM]);
  }
};
